module.exports = __webpack_public_path__ + "static/fonts/rajdhani-semibold-webfont.a501714.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/rajdhani-semibold-webfont.woff2
// module id = 104
// module chunks = 0